import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: '6b70a3b3-9764-4317-9ea7-d0a3c0b623f1',
  ENV: 'pusignan',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: 63,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
